import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, NgModule, ViewContainerRef, TemplateRef } from '@angular/core';
import { ProductService } from '../../services/product/product.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { CookieService } from 'ngx-cookie-service';
import { BrowserModule } from '@angular/platform-browser'
import { Subscription } from 'rxjs'
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Attributes } from '../../models/products/product.model';
import { ProductVariants } from '../../models/products/product.model';
import { Variants } from '../../models/products/product.model';
import { UtilitiesService } from '../../services/shared/utilities.service';
@Component({
    selector: 'app-slug',
    templateUrl: './slug.component.html',
    styleUrls: ['./slug.component.css']
})
/** slug component*/
export class SlugComponent {
  
  public variantsList: Variants[] = [];
  public attribute = new Attributes();
  public variants = new Variants();
  modalRef: BsModalRef;
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  config = {
    animated: true
  };
    /** slug ctor */
  constructor(private modalService: BsModalService, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly productService: ProductService, private readonly router: Router,private _avRoute: ActivatedRoute,
    private readonly utilitiesService: UtilitiesService) {
    this.toastr.setRootViewContainerRef(vcr);
      if (this._avRoute.snapshot.params["id"]) {
        this.GetAtrribute(this._avRoute.snapshot.params["id"]);
      }
      
    this.GetRowsPerPageList();
  }
 
  GetAtrribute(id: string) {
    this.productService.GetAttribute(id).subscribe(
      data => {
        this.attribute = data;
        this.GetVariantsList(this.attribute.attributeID);
        this.variants.attributeID = this.attribute.attributeID;
        this.variants.name = this.attribute.name;
      });
  }
    // Populate the row per page list
    GetRowsPerPageList() {
      this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
      this.rowsOnPage = this.arrRowsPerPage[0];
    }
  GetVariantsList(id: number) {

    this.productService.GetVariantsList(id).subscribe(
      data => {
        this.variantsList = data;
      });
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }
  confirm(): void {
    this.modalRef.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }
  deleteVariant(id) {

    var ans = confirm("Are you sure to delete this variant?");
    if (ans) {
      this.productService.DeleteVariant(id);
      setTimeout(() => {
        this.GetVariantsList(this.attribute.attributeID);
      }, 2000);
    }
  }
  AddVariants() {
    this.productService.AddVariant(this.variants).subscribe(
      data => {
        if (data) {
          this.toastr.success('Variant added Successfully.', 'Success');
          this.variants.slug = "";
          this.GetVariantsList(this.attribute.attributeID);
        }
        else {
          this.toastr.error('Variant already exist.', 'Error');
          this.attribute = new Attributes();
        }
      });
    this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/product-components/slug/slug.component.ts